// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"013d44de","586":"347237d8"}[chunkId] + ".chunk.css";
};